module.exports = __webpack_public_path__ + "img/Weapon_132.867839e3.png";